import { Component, inject, OnInit } from '@angular/core';
import { ScrollService } from 'src/app/services/scroll.service';

@Component({
  selector: 'app-buy-tickets',
  standalone: true,
  imports: [],
  templateUrl: './buy-tickets.component.html',
  styleUrls: ['./buy-tickets.component.scss'],
})
export class BuyTicketsComponent implements OnInit {
  private _scrollService = inject(ScrollService);

  ngOnInit(): void {
    // set isScrolled to false due to the actions affected by the scroll is only for the planner view
    this._scrollService.isScrolled.set(false);
  }
}
